/*
 * File: CustomDrawer.tsx
 * Project: a-a
 * File Created: Tuesday, 7th January 2025 11:42:27 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 12th March 2025 9:00:56 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { ReactElement, ReactNode, useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

const CustomDrawer = ({
  children,
  onClose,
  state,
}: {
  children: ReactNode;
  onClose: (event: React.KeyboardEvent | React.MouseEvent) => void;
  state: boolean;
}) => {
  console.log(children);
  return (
    <Drawer anchor={'right'} open={state} aria-hidden='false'>
      {children}
    </Drawer>
  );
};

export default CustomDrawer;
